"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const BaseConnection_1 = tslib_1.__importDefault(require("./BaseConnection"));
class ElectricityConnection extends BaseConnection_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 2000,
        defaultValue: 2900,
        description: 'The expected yearly electricity consumption during peak hours in kWh.',
    }),
    tslib_1.__metadata("design:type", Number)
], ElectricityConnection.prototype, "consumptionPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 900,
        defaultValue: 0,
        description: 'The expected yearly electricity consumption in kWh in the "off" hours. Omit if using one tariff',
    }),
    tslib_1.__metadata("design:type", Number)
], ElectricityConnection.prototype, "consumptionOffPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 200,
        defaultValue: 0,
        description: 'The expected amount of kWh that is returned on the net during the day',
    }),
    tslib_1.__metadata("design:type", Number)
], ElectricityConnection.prototype, "consumptionReturnPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 5,
        defaultValue: 0,
        description: 'The expected amount of kWh that is returned on the net in the "off" hours',
    }),
    tslib_1.__metadata("design:type", Number)
], ElectricityConnection.prototype, "consumptionReturnOffPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.ElectricityInstallationProfile)),
    (0, base_models_1.Docs)({
        example: offerstore_api_models_1.ElectricityInstallationProfile.E1A,
        defaultValue: offerstore_api_models_1.ElectricityInstallationProfile.E1C,
        description: `The profile of the electricity meter/installation.
heavily influences the supply rates. Describes the maximum usage of the building.
We try to find the profile if it is an existing customer, otherwise it will default to E1C.`,
    }),
    tslib_1.__metadata("design:type", String)
], ElectricityConnection.prototype, "installationProfile", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8742010202112',
        description: `States what kind of installation you have.
For example if you have 3x25 ampere or only 1x80.
This heavily influences the tariffs you receive.
You find the result under "Netbeheerder kosten".`,
    }),
    tslib_1.__metadata("design:type", String)
], ElectricityConnection.prototype, "captarEAN", void 0);
exports.default = ElectricityConnection;
